import { useEffect } from 'react';
import { global_var } from '../../services/cs-lab-config';
import { useParams, useNavigate } from "react-router-dom";
import IdeHeader from '../ide/ide-header';

const TuxPaint = () => {

  document.title = "CS Lab | Tux Paint";

  let { ideProjectId } = useParams();
  const navigate = useNavigate();

  // Listen to messages from the iframe (Flutter app)
  useEffect(() => {
    const handleMessage = (event) => {
      try {
        let data = event.data;
        if (typeof data === 'string') {
          data = JSON.parse(data);
        }
        if (data && data.type === "exitApproved") {
          if (window.pendingExitCallback) {
            window.pendingExitCallback();
            window.pendingExitCallback = null;
          } else {
            navigate(-1);
          }
        }
      } catch (e) {
        // Ignore non-JSON or unrelated messages
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  return (
    <div className="container-fluid p-0">
      <div className="row mt-1">
        <div className="col">
          <IdeHeader
            headerName="Tux Paint"
            hidePortfolio={true}
            onGoBack={(navigateBack) => {
              const iframe = document.getElementById("tuxPaintIframe");
              iframe?.contentWindow?.postMessage(JSON.stringify({ type: "triggerExit" }), "*");
              window.pendingExitCallback = navigateBack;
            }}
          />
          <iframe
            id="tuxPaintIframe"
            src={global_var.TUX_PAINT_ENDPOINT + '?token=' + sessionStorage.getItem('token') + (ideProjectId ? '&projectId=' + ideProjectId : '')}
            title="Tux Paint"
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default TuxPaint;
